<template>
  <el-dialog
    title="添加标签"
    :visible.sync="visible"
    :close-on-click-modal="false"
    :append-to-body="true"
    width="34%"
  >
    <el-form
      :model="formData"
      label-width="120px"
    >
      <el-form-item
        v-if="type == 'add'"
        label="标签分组："
      >
        <el-select
          v-model="formData.group_name"
          placeholder="请选择"
          @change="changeGroup"
        >
          <el-option
            v-for="(item,index) in groupList"
            :key="index"
            :label="item.group_name"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="标签名称：">
        <el-input
          v-model="formData.tag_name"
          autocomplete="off"
          placeholder="请输入标签名称"
        ></el-input>
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="onsubmit"
      >确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { tagAdd, tagEdit } from '@/api/customer'
export default {
  props: ['groupList'],
  data () {
    return {
      visible: false,
      formData: {
        group_name: '',
        tag_name: '',
        group_id: ''
      },
      type: '',
      row: {}
    }
  },
  methods: {
    showEdit (row, type) {
      this.type = type
      if (JSON.stringify(row) != '{}') {
        this.formData.tag_name = JSON.parse(JSON.stringify(row)).name
        this.row = row
      } else {
        this.formData = {
          group_name: '',
          tag_name: '',
          group_id: ''
        }
      }
      console.log(row);
      this.visible = true
    },
    changeGroup (e) {
      this.formData.group_name = e.group_name
      this.formData.group_id = e.group_id
    },
    async onsubmit () {
      try {
        if (this.type == 'add') {
          const _response = await tagAdd(this.formData)
          const { error, data, msg } = _response
          if (error !== 0) return new Error(msg)
          this.$message({
            message: '恭喜你，添加成功！',
            type: 'success'
          });
        } else {
          const _response = await tagEdit({
            id: this.row.id,
            name: this.formData.tag_name,
            order: '',
            type: 2
          })
          const { error, data, msg } = _response
          if (error !== 0) return new Error(msg)
          this.$message({
            message: '恭喜你，修改成功！',
            type: 'success'
          });
        }
        this.visible = false
        this.$parent.getList()
      } catch (e) {

      }
    }
  }
}
</script>

<style lang="less" scoped>
.el-input,
.el-select {
  width: 400px;
}
</style>